import { Copy, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useCopyToClipboard } from "@/components/useCopyToClipboard";

interface CopyValueProps {
  value?: string;
  className?: string;
  showIcon?: boolean;
  timeout?: number;
  withToast?: boolean;
  children?: React.ReactNode;
}

export const CopyValue = ({
  value,
  className = "",
  showIcon = true,
  timeout = 2000,
  withToast = true,
  children
}: CopyValueProps) => {
  const { copy, isCopied } = useCopyToClipboard();

  const handleCopy = async () => {
    if (!value) {
      return;
    }

    await copy(value, { timeout, withToast });
  };

  if (!value) {
    return <span className={className}>-</span>;
  }

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={handleCopy}
      animations="none"
      className={`h-auto max-w-full overflow-hidden p-0 font-normal text-foreground ${className} select-text cursor-pointer`}
    >
      <span className="flex min-w-0 max-w-full flex-nowrap items-center gap-1 overflow-hidden">
        <span className="min-w-0 truncate">{children || value}</span>
        {showIcon &&
          (isCopied ? <Check className="text-green-500" /> : <Copy className="opacity-50" />)}
      </span>
    </Button>
  );
};

export const CopyIPAddress = CopyValue;
